import React, { useEffect, useState } from "react";
import logo from "../../assets/images/Vi4x_logo.png";
import logoUnderMaintaintance from "../../assets/images/UnderMaintaintance.gif";
import BaseHome from "./BaseHome";
import { ExitToApp } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

const UnderMaintaintance = () => {
  const { t } = useTranslation();

  return (
    <BaseHome
      title={t("esports")}
      onBackClick={() => {
        // You might want to handle navigation here
      }}
    >
    <div style={{display:"flex",justifyContent:"center",alignItems:"center",flexDirection:"column",margin:"20px"}}>
      <img
        src={logo}
        alt="Vi4x Logo"
        // className="logo"
        style={{ width: "120px", margin: "32px 0" }}
      />
 

     
      <h1 style={{marginTop:"80px"}}>{t("under_maintenance_title", "Under Maintenance")}</h1>
        <img
          src={logoUnderMaintaintance}
          alt="Vi4x Logo"
          // className="logo"
          style={{ width: "200px", margin: "32px 0" }}
        />
        <p style={{ margin: "20px", textAlign: "-webkit-center"}}>
        {t(
          "under_maintenance_message",
          "We are currently performing scheduled maintenance to improve your experience. Please check back soon."
        )}
      </p>
        
        
      </div>
    </BaseHome>
  );
};

export default UnderMaintaintance;
